import React, { FC } from 'react'
import { HStack, Typography, XelaColor } from '@/XelaReact'
import { router } from '@inertiajs/react'
import Notification = App.Models.Notification

const AgentInviteAcceptedNotification: FC<{
  notification: Notification
  portal?: string
}> = ({ notification, portal = 'Agency' }) => {
  return (
    <HStack
      spacing="3px"
      style={{
        flexWrap: 'wrap',
        cursor: 'pointer',
        padding: '12px',
      }}
      onClick={() => {
        if (portal === 'B2B') {
          router.visit('/b2b/agents/' + notification.data.agent_id)
        }
      }}
    >
      <Typography variant="body-small" color={XelaColor.Gray6}>
        Agent
      </Typography>
      <Typography variant="body-small" color={XelaColor.Pink3}>
        {notification.data.event_by}
      </Typography>
      <Typography variant="body-small" color={XelaColor.Gray6}>
        accepted an invitation from
      </Typography>
      <Typography variant="body-small-bold" color={XelaColor.Gray3}>
        {notification.data.user_name}
      </Typography>
    </HStack>
  )
}

export default AgentInviteAcceptedNotification
